import React from "react";
import "./style.sass";

function Pagination({ currentPage, totalPages, onPageChange }) {
  const getPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    pages.push(1);

    if (startPage > 2) {
      pages.push("start-ellipsis");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push("end-ellipsis");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const pages = getPageNumbers();

  return (
    <div className="pagination">
      <button
        className="pagination__button"
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      <div className="pagination__pages">
        {pages.map((page, index) => {
          if (page === "start-ellipsis" || page === "end-ellipsis") {
            return <span key={index}>...</span>;
          }

          return (
            <button
              key={index}
              onClick={() => onPageChange(page)}
              className={`pagination__page ${
                page === currentPage ? "active" : ""
              }`}
            >
              {page}
            </button>
          );
        })}
      </div>

      <button
        className="pagination__button"
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
}

export default Pagination;
